import React from 'react';
import { SingleScreenWrapper } from '../../components/SingleScreen/requestWrapper';

export const HomePageFeRender = () => {
    return (
        <>
            <SingleScreenWrapper
                channelConfigs={[
                    { type: 'category', title: '汽车', size: 4, target: 'http://auto.sohu.com/', placeholder: 'auto', spmCode: { title: 'auto-nav', content: 'auto-news1' }, source: [11596]},
                    { type: 'category', title: '科技', size: 4, target: 'http://it.sohu.com/', placeholder: 'tech', spmCode: { title: 'tech-nav', content: 'tech-news1' }, source: [11605, 13456]},
                    { type: 'category', title: '房产', size: 4, target: 'https://house.focus.cn/', placeholder: 'focus', spmCode: { title: 'focus-nav', content: 'focus-news1' }, source: [13676]},
                    { type: 'category', title: '健康', size: 4, target: 'http://health.sohu.com/', placeholder: 'health', spmCode: { title: 'health-nav', content: 'health-news1' }, source: [11592, 13457]},
                ]}
                enumConfigs={[
                    { titles:['买车', '用车', '车视频'], source: [11597, 11598, 11599], spm: 'auto'},
                    { titles:['互联网', '通讯', '科学'], source: [11606, 11607, 11608], spm: 'tech'},
                    { titles:['家居', '二手房'], source: [13677, 13678], spm: 'focus'},
                    { titles:['养生', '医疗', '两性健康'], source: [11593, 11594, 11595], spm: 'health'},
                ]}
                recommendConfigs={[
                    { source: 11633, size: 2, title: '情感', spm: 'emotion'},
                    { source: 11634, size: 2, title: '运势', spm: 'fate'},
                    { source: 11635, size: 2, title: '测评', spm: 'assessment'},
                    { source: 11636, size: 2, title: '揭秘', spm: 'secrets'},
                ]}
                rectAdConfig={{ regionId: 12746, spm: 'god-side-4', placeholder: {source: 13704, title: '美妆种草', slogan: '种草达人 精选推荐', bgImage: '//statics.itc.cn/PC_classichome/mzzc.png', page:'https://www.sohu.com/column/10571'}}}
                longAdConfig={{ regionId:12749, spm: 'god-middle-3'}}
                />
            <SingleScreenWrapper
                channelConfigs={[
                    { type: 'category', title: '时尚', size: 4, target: 'http://fashion.sohu.com/', placeholder: 'fashion', spmCode: { title: 'fashion-nav', content: 'fashion-news1' }, source: [11613, 13458]},
                    { type: 'category', title: '文化', size: 4, target: 'http://cul.sohu.com/', placeholder: 'cul', spmCode: { title: 'cul-nav', content: 'cul-news1' }, source: [11621, 13460]},
                    { type: 'category', title: '教育', size: 4, target: 'http://learning.sohu.com/', placeholder: 'learning', spmCode: { title: 'learning-nav', content: 'learning-news1' }, source: [11617, 13459]},
                    { type: 'category', title: '旅游', size: 4, target: 'http://travel.sohu.com/', placeholder: 'travel', spmCode: { title: 'travel-nav', content: 'travel-news1' }, source: [11625]},
                ]}
                enumConfigs={[
                    { titles:['时装', '美容', '男士'], source: [11614, 11615, 11616], spm: 'fashion'},
                    { titles:['人物', '读书', '艺术'], source: [11622, 11623, 11624], spm: 'cul'},// learning
                    { titles:['中小学', '高考', '校园'], source: [11618, 11619, 11620], spm: 'learning'},// cul
                    { titles:['国内游', '境外游', '攻略'], source: [11626, 11627, 11628], spm: 'travel'},
                ]}
                recommendConfigs={[
                    { source: 11637, size: 2, title: '美食', spm: 'food'},
                    { source: 11638, size: 2, title: '育儿', spm: 'baby'},
                    { source: 11639, size: 2, title: '教程', spm: 'course'},
                    { source: 11640, size: 2, title: '摄影', spm: 'photography'},
                ]}
                rectAdConfig={{ regionId: 12747, spm: 'god-side-5', placeholder: {source: 13705, title: '职场新鲜事', slogan: '职场见闻 一网打尽', bgImage: '//statics.itc.cn/PC_classichome/zcxxs.png',page:'https://www.sohu.com/column/10572'}}}
            />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/pages/HomePageFeRender/index.tsx